import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CheckoutSection from './utils/Checkout.Section';
import CheckoutSectionContent from './utils/Checkout.SectionContent';
import Radio from './utils/Checkout.Radio';
import { setDelivery } from '../../Actions/Checkout.action';
import { translate } from '../../Services/translation';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

const DeliveryMethods = () => {
  const dispatch = useDispatch();
    const checkout = useTypedSelector((state) => state.checkout);
    const { deliveryMethods, selectedDeliveryMethod, selectedPaymentMethod } = checkout.payload;


  // Try without setting the delivery method async. Done in init code in BE
  // useEffect(() => {
  //   if (!selectedDeliveryMethod) return;

  //   dispatch(setDelivery(selectedDeliveryMethod));
  // }, []);

  return selectedPaymentMethod && selectedPaymentMethod.integrationType != "IframeCheckout" ? (
    <CheckoutSection title={translate('checkout.delivery.title')}>
      <CheckoutSectionContent className="d-flex">
        {deliveryMethods &&
          deliveryMethods.map((method) => (
            <Radio
              key={method.id + 'delivery-method'}
              title={method.name}
              description={method.description}
              cost={method.formattedPrice}
              logo={
                method.imageUrl && (
                  <img src={method.imageUrl} alt={method.name} />
                )
              }
              stateKey={'delivery-method'}
              id={method.id}
              checked={method.id === selectedDeliveryMethod?.id}
              onChange={() => dispatch(setDelivery(method))}
            />
          ))}
      </CheckoutSectionContent>
    </CheckoutSection>
  ) : null;
};

export default DeliveryMethods;
